import { useAtom } from 'jotai'

import { atomLoginStatus, LoginStatus } from '@/stores/login'

export default function WaitingSigning() {
  const [loginStatus] = useAtom(atomLoginStatus)

  if (loginStatus !== LoginStatus.walletWaitingSigning) return null

  return (
    <div className="">
      <div className="h-8"></div>
      <div className="flex justify-center">
        <LoadingIcon />
      </div>
      <div className="h-4"></div>
      <h3 className="text-Text-Primary font-semibold text-2xl leading-8 tracking-normal text-center align-middle">
        Waiting for Signing
      </h3>
      <p className="text-Text-Secondary font-medium text-base leading-6 tracking-normal text-center">
        For the best experience, connect only one wallet at a time
      </p>
    </div>
  )
}

const LoadingIcon = () => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="3.5"
        cy={12}
        r="2.5"
        transform="rotate(90 3.5 12)"
        fill="#243146"
        fillOpacity="0.32"
      />
      <circle
        cx={12}
        cy="3.5"
        r="2.5"
        transform="rotate(-180 12 3.5)"
        fill="#243146"
        fillOpacity="0.32"
      />
      <circle
        cx="20.5"
        cy={12}
        r="2.5"
        transform="rotate(90 20.5 12)"
        fill="#243146"
        fillOpacity="0.32"
      />
      <circle
        cx={12}
        cy="20.5"
        r="2.5"
        transform="rotate(-180 12 20.5)"
        fill="#243146"
        fillOpacity="0.32"
      />
    </svg>
  )
}
